import React from 'react'
import { useI18N } from '../../../libraries/i18n/hook'
import * as utilsLib from '../../../libraries/utils'
import TextInput from '../../components/form/TextInput'
import TypeSelectBox from './TypeSelectBox'
import ListWithStickyFilters from '../../components/layout/ListWithStickyFilters'
import SearchIcon from '../../../assets/icons/mag-glass.svg?react'
import EventsList from '../../components/events/List'
import { useEvents } from './hooks'
import ToggleButton from '../../components/form/ToggleButton'
import PageHeading from '../../components/layout/PageHeading'
import { useEventFilter } from '../../../libraries/search/filters'

const AllEvents = () => {
  const { t } = useI18N()
  return (
    <div>
      <PageHeading>{t('events.title')}</PageHeading>
      <ListWithStickyFilters
        Items={EventsExplorer as React.FC}
        FiltersBox={EventFiltersBox as React.FC}
      />
    </div>
  )
}

const EventFiltersBox: React.FC = () => {
  const { t } = useI18N()
  const { filters, setFilters } = useEventFilter()
  const [searchText, setSearchText] = React.useState(filters.text || '')

  React.useEffect(() => {
    setSearchText(filters.text || '')
  }, [filters.text])

  const debouncedHandleTextChange = React.useMemo(() => utilsLib.debounceFunc((e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters({ text: e.target.value.trim() })
  }, 300), [setFilters])

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
    debouncedHandleTextChange(e)
  }
  return (
    <>
      <div className='mt-2' />
      <TextInput icon={<SearchIcon className='w-5' />} className='w-full' value={searchText} onChange={handleTextChange} placeholder={t('content.searchByKeyword')} />
      <div className='mt-5 sm:mt-6' />
      <TypeSelectBox onChange={setFilters} values={filters.typeIds} />
      <div className='mt-5 sm:mt-6' />
      <ToggleButton id='rsvp' name='rsvpStatus' label={t('events.rsvp.attending')} onChange={() => setFilters({ rsvpStatus: filters.rsvpStatus === true ? false : true })} checked={!!filters.rsvpStatus} />
    </>
  )
}

const EventsExplorer: React.FC = () => {
  const { filters, setFilters } = useEventFilter()
  const { data, isLoading, error } = useEvents(filters)
  const { data: defaultEvents } = useEvents()
  const totalResultsWithDefaultFilters = defaultEvents?.length ?? 0
  const handleClearFilters = () => {
    setFilters({}, true)
  }

  return <EventsList data={data} isLoading={isLoading} error={error} onClearFilter={handleClearFilters} totalResults={totalResultsWithDefaultFilters} />
}

export default AllEvents
